import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../api/api";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { IDiscount } from "../../../types/discount.type";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditDiscountForm from "../forms/EditDiscountFrom/EditDiscountForm";
import ViewDiscountForm from "../forms/EditDiscountFrom/ViewDiscountForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  discount: IDiscount;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
  products: IProduct[];
}

const EditDiscountModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteDiscount(props.discount.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err: any) {
      console.error(err.message);
      if (
        err.response.data.message ===
        "Cannot delete provider with associated resources."
      ) {
        toast.error(
          "Не можливо видалити дискоунт, якщо є повʼязаний з ним ресурс."
        );
      }
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення дісконту"
              subTitle="Ви дійсно хочете видалити цей дісконт? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати дісконт"
              subTitle='Редагуйте інформацію. Внесіть необхідні зміни та натисніть "Зберегти".'
            ></ModalTitle>

            <EditDiscountForm
              onApply={onPressApply}
              onClose={() => setIsDelete(true)}
              products={props.products}
              discount={props.discount}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.nameContainer}>
                <span
                  className={styles.name}
                >{`${props.discount.percent} %`}</span>
              </div>
            </div>
            <ViewDiscountForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              discount={props.discount}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditDiscountModal;
